import React from 'react'
import { format as formatDate } from 'date-fns'

import useStyles from './styles'

const TimelineSurvey = ({ content, date }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {content.body ?? content} {formatDate(date, 'MMM d, h:mm aaa')}
    </div>
  )
}

export default TimelineSurvey
